module.exports = __webpack_public_path__ + "assets/img/what.ca61bdc0.svg";